
            import { Injectable } from "@angular/core";
            import { RockService } from '../rock.service';
            import { RockFieldConfigurationValue, RockModelAssessment, RockModelAssessmentType, RockModelBinaryFile, RockModelBinaryFileType, RockModelCategory, RockModelDefinedValue, RockModelDocument, RockModelDocumentType, RockModelEntityType, RockModelPerson, RockModelPersonAlias, RockModelPhoneNumber, RockModelUserLogin, RockWebCacheAttributeCache, RockWebCacheAttributeValueCache} from './Assessments.models';

            @Injectable()
            export class AssessmentsService extends RockService {
            
                override entityType = 'Assessments';
            
                    GetAssessments() {
                        return this.get(`Assessments`);
                    }

                    PostAssessments(value: RockModelAssessment) {
                        return this.post(`Assessments`, value);
                    }

                    GetAssessmentsByid(id: number) {
                        return this.get(`Assessments/${id}`);
                    }

                    PutAssessmentsByid(id: number, value: RockModelAssessment) {
                        return this.put(`Assessments/${id}`, value);
                    }

                    DeleteAssessmentsByid(id: number) {
                        return this.delete(`Assessments/${id}`);
                    }

                    PatchAssessmentsByid(id: number, values: object) {
                        return this.patch(`Assessments/${id}`, values);
                    }

                    PostAssessmentsAttributeValueByid(id: number) {
                        return this.post(`Assessments/AttributeValue/${id}`);
                    }

                    DeleteAssessmentsAttributeValueByid(id: number) {
                        return this.delete(`Assessments/AttributeValue/${id}`);
                    }

                    GetAssessmentsDataViewByid(id: number) {
                        return this.get(`Assessments/DataView/${id}`);
                    }

                    GetAssessmentsFollowedItems() {
                        return this.get(`Assessments/FollowedItems`);
                    }

                    GetAssessmentsGetByAttributeValue() {
                        return this.get(`Assessments/GetByAttributeValue`);
                    }

                    GetAssessmentsInDataViewBydataViewIdByentityId(dataViewId: number, entityId: number) {
                        return this.get(`Assessments/InDataView/${dataViewId}/${entityId}`);
                    }

                    PostAssessmentsLaunchWorkflowByid(id: number, workflowAttributeValues: object) {
                        return this.post(`Assessments/LaunchWorkflow/${id}`, workflowAttributeValues);
                    }

                    PutAssessmentsSetContextByid(id: number) {
                        return this.put(`Assessments/SetContext/${id}`);
                    }

                    OptionsAssessmentsSetContextByid(id: number) {
                        return this.options(`Assessments/SetContext/${id}`);
                    }

}